import React from 'react';
import { Image, Linking, Pressable, View } from 'react-native';
import { Text } from '@/components/Text';
import { useDialog } from '@/hooks/useDialog';
import constants from '@/config/constants';
import { PREPARED_DIALOGS } from '@/components/ui/shared/Dialog/constants';

export function Footer() {
  const { showDialog } = useDialog();
  return (
    <View className="flex-row justify-between items-end mb-2 ">
      <View>
        <View className="w-12 h-8 mb-2 ">
          <Image
            className="w-full h-full"
            resizeMode="contain"
            source={require('@/assets/ce4.png')}
          />
        </View>
        <Text>App Version {constants.appVersion}</Text>
        <Text>UDI-DI {constants.udiDi}</Text>
        <Text>UDI-PI {constants.udiPi()}</Text>
      </View>
      <View className="flex-row gap-8">
        <Pressable
          onPress={() => Linking.openURL('https://neolexon.de/impressum')}
        >
          <Text className="text-xl">Impressum</Text>
        </Pressable>
        <Pressable
          onPress={() =>
            Linking.openURL('https://neolexon.de/datenschutzerklaerung')
          }
        >
          <Text className="text-xl">Datenschutz</Text>
        </Pressable>
        <Pressable onPress={() => showDialog(PREPARED_DIALOGS.kontaktDialog())}>
          <Text className="text-xl">Kontakt</Text>
        </Pressable>
      </View>
    </View>
  );
}
